// Step-5 (Cost-Share) FX helpers for the reviewer UI.
//
// When a foreign-currency claim can't be auto-converted, Step 5 ESCALATES and
// the reviewer must convert the invoice amount manually against the monthly AWS
// Finance rate. In that case the Cost-Share box offers a link to the OEM FO
// Monthly Currency Converter. This module isolates the "should we show that
// link?" decision so it is unit-testable (the DOM render in FundingRequestDetail
// is not, per the known cloudscape/@testing-library gap).

// OEM FO Monthly Currency Converter (QuickSight). Opened in a new tab from the
// Cost-Share box on an FX escalation.
export const OEM_FX_CONVERTER_URL =
  'https://us-east-1.quicksight.aws.amazon.com/sn/account/amazonbi/apps/65ca9917-ea38-44cc-a89b-9a80409b5841/view/OEM-FO-Monthly-Currency-Converter';

// Show the converter link on EVERY Cost-Share FX escalation where the currencies
// differ:
//   1. Step 5 escalated (status === 'escalate') — the reviewer is the one who
//      must convert; a pass/reject has already been decided.
//   2. the invoice currency is present and differs from the claim currency.
// A same-currency claim or a pass/reject never shows the link.
//
// There is deliberately NO fx_applied condition. Any rate the engine fetched
// from Frankfurter /latest is ADVISORY only; the OFFICIAL conversion must be
// done against the OEM FO Monthly Currency Converter. Step 5 escalates a
// different-currency claim (fx_rate_basis_needs_confirmation) WITH an advisory
// fx_applied daily rate attached, so gating on !fx_applied hid the official
// converter link on exactly the escalations that need it. The presence of an
// advisory daily rate must not hide the link.
export function needsManualFxConversion(step5, claimCurrency) {
  if (!step5 || typeof step5 !== 'object') return false;
  if (step5.status !== 'escalate') return false;
  const invoiceCurrency = step5.invoice_currency;
  if (!invoiceCurrency) return false;
  return invoiceCurrency !== claimCurrency;
}
